window.addEventListener("phx:submit-form", (e) => {
  document.getElementById(e.detail.id).requestSubmit()
})
